import { render } from "./CategoryGlyph.vue?vue&type=template&id=a73132a0"
import script from "./CategoryGlyph.vue?vue&type=script&lang=js"
export * from "./CategoryGlyph.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__